import { createContext } from 'react';

/** Where a step renders its Back / Next bar, below the scrolling content like the onboarding footer. */
export const ConsumerFooterSlot = createContext<HTMLDivElement | null>(null);
